import React from 'react';

import { CreateTicketContainer } from 'containers';
import { SupportMyTicketsPage } from 'pages';

export const SupportPage = () => (
  <div>
    <CreateTicketContainer />
    <SupportMyTicketsPage />
  </div>
);
